import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "data-compact"]




export default /*#__PURE__*/_defineComponent({
  ...{
    name: "inn-input",
},
  __name: 'Input',
  props: /*#__PURE__*/_mergeModels({
    placeholder: {
        type: String,
        required: false,
        default: "Zoeken...",
    },
    compact: {
        type: Boolean,
        required: false,
        default: false,
    },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {





const model = _useModel(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    placeholder: __props.placeholder,
    "data-compact": __props.compact
  }, null, 8, _hoisted_1)), [
    [_vModelText, model.value]
  ])
}
}

})